function FooterSection(props) {
  const {
    titleIcon,
    title,
    children,
    buttonLabel,
    showButton = true,
    onButtonClick = () => { },
  } = props || {}
  return (
    <div className="info-box h-full bg-theme_clr1 text-white flex flex-col justify-between rounded-xl p-4 xl:p-5">
      <div className="title-info text-[23px] font-bold font-manrope flex items-center gap-2 leading-tight mb-4">
        {titleIcon && <img src={titleIcon} alt="Milestones" className="inline w-[30px] h-[30px]" />}
        {title}
      </div>
      {children}
      <div className="btn-wrapper mt-2">
        <button type="button" className="btn-custom4 text-[1vw]" onClick={onButtonClick}>
          {buttonLabel}
        </button>
      </div>
    </div>
  );
}

export default FooterSection;
